export const ApiDef_PermissionGroup = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map